import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: flex;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const BoxSideBar = styled.div`
  z-index: 100 !important;
  width: 280px;
  transition: width 0.3s;
  position: fixed !important;
  top: 60px;
  left: 0;
  height: calc(100vh - 60px);
  border-right: 1px solid #edeef3;
  max-height: calc(100vh - 60px);
  overflow: auto;
  background: white !important;
  display: block !important;
  visibility: visible !important;

  &.collapsed {
    width: 50px;
  }

  @media (max-width: 768px) {
    position: fixed !important;
    top: 60px;
    left: 0;
    width: 280px;
    height: calc(100vh - 60px);
    max-height: calc(100vh - 60px);
    border-right: 1px solid #edeef3;
    z-index: 99 !important;
    transition: left 0.3s ease;
    background: white !important;
    display: block !important;
    visibility: visible !important;

    &.collapsed {
      left: -280px;
      width: 280px;
    }
  }

  @media (max-width: 470px) {
    width: 280px;
    max-width: 280px;
    display: block !important;
    visibility: visible !important;

    &.collapsed {
      left: -280px;
      width: 280px;
      max-width: 280px;
    }
  }
`;

export const MobileOverlay = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: ${props => props.isCollapsed ? 'none' : 'block'};
    position: fixed;
    top: 60px;
    left: 0;
    width: 100%;
    height: calc(100vh - 60px);
    background: rgba(0, 0, 0, 0.5);
    z-index: 98;
    transition: opacity 0.3s ease;
  }

  @media (max-width: 470px) {
    top: 60px;
    left: 0;
    width: 100%;
    height: calc(100vh - 60px);
  }
`;

export const BoxContent = styled.div`
  background: #ffffff;
  left: 280px;
  width: calc(100% - 280px);
  height: 100vh;
  position: relative;
  transition: width 0.3s, left 0.3s;
  z-index: 1;

  &.collapsed {
    left: 50px;
    width: calc(100% - 50px);
  }

  @media (max-width: 768px) {
    left: 0;
    width: 100%;
    height: 100vh;
    min-height: calc(100vh - 60px);

    &.collapsed {
      left: 0;
      width: 100%;
    }
  }

  @media (max-width: 470px) {
    left: 0;
    width: 100%;
    height: 100vh;
    min-height: calc(100vh - 60px);

    &.collapsed {
      left: 0;
      width: 100%;
    }
  }
`;

export const CustomMain = styled.main`
  position: relative;
  top: 60px;
  height: calc(100vh - 60px);
  padding: 2px;
  z-index: 1;

  @media (max-width: 768px) {
    top: 60px;
    height: calc(100vh - 60px);
    padding: 10px;
  }

  @media (max-width: 550px) {
    padding: 8px;
  }

  @media (max-width: 470px) {
    top: 60px;
    height: calc(100vh - 60px);
    padding: 5px;
  }
`;
